import React from 'react';
import { computeFeeTotals, formatPercent, formatAuditDate } from './feeUtils';

const NumberCell = ({ row, field, changed, onChange }) => (
  <td>
    {row.is_available ? (
      <input
        type="number"
        className={`form-control form-control-sm ${changed ? 'border-warning' : ''}`}
        style={{ maxWidth: '110px' }}
        value={row[field] ?? ''}
        onChange={(e) => onChange(row.portfolio_code, field, e.target.value === '' ? null : parseFloat(e.target.value))}
        step="0.0001"
      />
    ) : <span className="text-muted">-</span>}
  </td>
);

const FeeRow = ({ row, changed, multiplier, onChange, onToggleAvailable, onCopyClick }) => {
  const rowStyle = !row.is_available
    ? { opacity: 0.5, backgroundColor: '#f8f9fa' }
    : row.in_registry
      ? { backgroundColor: 'rgba(240, 165, 0, 0.08)' }
      : {};
  const totals = computeFeeTotals(row, multiplier);
  const unmapped = row.series === 'Unmapped';

  return (
    <tr style={rowStyle}>
      <td style={row.in_registry ? { boxShadow: 'inset 3px 0 0 #f0a500' } : {}}>
        <span className="fw-semibold" style={{ whiteSpace: 'nowrap' }}>
          {row.in_registry && (
            <span style={{ color: '#f0a500' }} className="me-1" title="Portfolio Registry entry — canonical portfolio, keep fees accurate">★</span>
          )}
          {row.portfolio_code}
          {unmapped && (
            <span className="text-warning ms-1" title="No master SAA mapped — map it in Investment Config → Portfolio Mapping">⚠</span>
          )}
        </span>
      </td>
      <td>
        <span
          className="d-inline-block text-truncate"
          style={{ maxWidth: '180px' }}
          title={row.portfolio_name || ''}
        >
          {row.portfolio_name || <span className="text-muted fst-italic">not traded yet</span>}
        </span>
      </td>
      <td>
        {row.risk != null
          ? <span className="badge" style={{ backgroundColor: '#072040' }}>SRM {row.risk}</span>
          : row.growth_exposure != null
            ? <span className="badge bg-secondary">{Math.round(row.growth_exposure * 100)}% Gr</span>
            : <span className="text-muted">-</span>}
      </td>
      <td><span className="text-muted">{row.blender_code || '-'}</span></td>
      <td>
        {row.is_available ? (
          <input
            type="date"
            className={`form-control form-control-sm ${changed ? 'border-warning' : ''}`}
            style={{ maxWidth: '140px' }}
            value={row.pds_date || ''}
            onChange={(e) => onChange(row.portfolio_code, 'pds_date', e.target.value || null)}
          />
        ) : (
          <span className="text-muted">N/A</span>
        )}
      </td>
      <NumberCell row={row} field="investment_mgmt_fee" changed={changed} onChange={onChange} />
      <NumberCell row={row} field="sub_portfolio_mgmt_fee" changed={changed} onChange={onChange} />
      <NumberCell row={row} field="indirect_costs" changed={changed} onChange={onChange} />
      <NumberCell row={row} field="aggregate_rebates" changed={changed} onChange={onChange} />
      <td style={{ backgroundColor: '#f0f0f0' }}>
        <span className="fw-semibold">
          {totals.total_fixed_cost != null ? formatPercent(totals.total_fixed_cost) : '-'}
        </span>
      </td>
      <NumberCell row={row} field="transaction_fees" changed={changed} onChange={onChange} />
      <NumberCell row={row} field="performance_fees" changed={changed} onChange={onChange} />
      <td style={{ backgroundColor: '#f0f0f0' }}>
        <span className="fw-semibold">
          {totals.total_variable_cost != null ? formatPercent(totals.total_variable_cost) : '-'}
        </span>
      </td>
      <td>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={row.is_available}
            onChange={() => onToggleAvailable(row.portfolio_code)}
          />
        </div>
      </td>
      <td>
        <small className="text-muted" title={row.updated_by || ''}>
          {formatAuditDate(row.updated_at)}
          {row.updated_by && <><br />{row.updated_by}</>}
        </small>
      </td>
      <td>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onCopyClick(row.portfolio_code)}
          title="Copy fees from another portfolio"
        >
          ⧉
        </button>
      </td>
    </tr>
  );
};

export default FeeRow;
